import { type Vec3, vec3Result } from "geom/vec3";

export function eyePosFromElevationViewVector(
  elevationViewDirX: number,
  elevationViewDirY: number,
  elevationViewDirZ: number,
  distance: number = 1000,
): Vec3 {
  vec3Result[0] = elevationViewDirX * -distance;
  vec3Result[1] = elevationViewDirY * -distance;
  vec3Result[2] = elevationViewDirZ * -distance;
  return vec3Result;
}
